export const buildAudienceEmailsEndpoint = (audienceType, filters = {}) => {
  const params = new URLSearchParams();
  if (filters.startDate) params.set('startDate', filters.startDate);
  if (filters.endDate) params.set('endDate', filters.endDate);

  const query = params.toString();
  return `/api/email-campaigns/audience/${encodeURIComponent(audienceType)}/emails${query ? `?${query}` : ''}`;
};

export const canRetryEmailCampaign = (status) => ['partial', 'failed'].includes(status);

export const EMAIL_ATTACHMENT_ACCEPT = '.pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg,.txt';
const MAX_ATTACHMENT_BYTES = 5 * 1024 * 1024;
const ALLOWED_ATTACHMENT_TYPES = new Set([
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'image/jpeg',
  'image/png',
  'text/plain',
]);
const ALLOWED_ATTACHMENT_EXTENSIONS = new Set([
  'pdf', 'doc', 'docx', 'xls', 'xlsx', 'png', 'jpg', 'jpeg', 'txt',
]);

export const validateEmailAttachment = (file) => {
  if (!file) return null;
  if (file.size > MAX_ATTACHMENT_BYTES) return 'Attachment must be 5 MB or smaller.';
  const extension = file.name.split('.').pop()?.toLowerCase();
  if (!ALLOWED_ATTACHMENT_TYPES.has(file.type) || !ALLOWED_ATTACHMENT_EXTENSIONS.has(extension)) {
    return 'Use a PDF, Word, Excel, PNG, JPEG, or text file.';
  }
  return null;
};

export const createEmailCampaign = async (api, campaignData, attachment) => {
  if (!attachment) return api.post('/api/email-campaigns', campaignData);

  const attachmentError = validateEmailAttachment(attachment);
  if (attachmentError) throw new Error(attachmentError);

  const sendImmediately = !campaignData.scheduledAt && !campaignData.saveAsDraft;
  const response = await api.post('/api/email-campaigns', {
    ...campaignData,
    saveAsDraft: true,
  });
  const campaignId = response.data.campaign.id;

  await api.put(`/api/email-campaigns/${campaignId}/attachment`, attachment, {
    headers: {
      'Content-Type': attachment.type,
      'X-Attachment-Name': encodeURIComponent(attachment.name),
    },
  });

  if (sendImmediately) {
    const sendResponse = await api.post(`/api/email-campaigns/${campaignId}/send`);
    response.data.campaign = {
      ...response.data.campaign,
      status: sendResponse.data.delivery.status,
      sent_count: sendResponse.data.delivery.sent,
      failed_count: sendResponse.data.delivery.failed,
    };
  }

  return response;
};
